import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { BiometryType } from 'src/app/@core/constants';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';
import { PosOrderObservationsService } from 'src/app/@core/services/pos-order-observations.service';
import { FileUtils } from 'src/app/@core/utils/file-utils';
import { Customer } from 'src/app/models/customer';
import { BiometryAuthCreditRequest } from 'src/app/models/request/biometry-auth-credit-request';
import { BiometryValidationResponse } from 'src/app/models/response/biometry-validation-response';
import { CreditStatusFranchisedResponseModel } from 'src/app/models/response/customerCreditStatusResponseModel';
import { AuthService } from 'src/app/services/auth.service';
import { BiometryService } from 'src/app/services/biometry.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { ParamsService } from 'src/app/services/params.service';
import Swal from 'sweetalert2';
import { BiometryFingerPrintComponent } from './biometryFingerPrint/biometryFingerprint.component';

@Component({
  selector: 'app-biometry',
  templateUrl: './biometry.component.html',
  styleUrls: ['./biometry.component.sass'],
})
export class BiometryComponent implements OnInit {
  @ViewChild('uploadCanvas') uploadCanvas: any;
  @ViewChild('hardwareVideo') hardwareVideo: any;
  @ViewChild('takenCanvas') takenCanvas: any;
  @ViewChild('biometryFingerPrint')
  biometryFingerPrintComponent!: BiometryFingerPrintComponent;

  @Input() customer: Customer = new Customer();
  @Input() isForInvoice = false;
  @Input() isForCashLoan = false;
  @Input() isForCreditRequest = false;
  @Input() showActionButtonWithApprove = false;
  @Input() showActionButtonWithoutApprove = false;
  @Input() textActionButtonWithApprove = ``;
  @Input() textActionButtonWithoutApprove = ``;
  @Input() creditRequestNumber = ``;
  @Input() orderCode = ``;
  @Input() showTokenButton: boolean = true;
  @Input() showDefaultText: boolean = false;
  @Input() selectedUserBranchCode: string = "";
  @Input() selectedUserSalesOrg: string = "";
  @Input() cashLoanReasonCode: string = "";
  @Input() cashLoanReasonDescription: string = "";

  @Input('pictureUrl') set pictureUrlFromDocuments(pictureUrl: string) {
    this.picture = pictureUrl;
    if (pictureUrl != '') {
      const image = new Image();
      image.onload = () => {
        this.takenCanvas.nativeElement
          .getContext('2d')
          .drawImage(image, 0, 0, 640, 480);
      };
      image.src = this.picture;
      this.toggleVideo(false, true);
    }
  }

  @Output() biometryResultEmitter =
    new EventEmitter<BiometryValidationResponse>();
  @Output() biometryErrorEmitter = new EventEmitter();
  @Output() cleanEmitter = new EventEmitter();
  @Output() clickActionButtonWithApprove = new EventEmitter();
  @Output() clickActionButtonWithoutApprove = new EventEmitter();
  @Output() pictureTakenEmitter = new EventEmitter<string>();

  public filename: string = '';
  public picture: string = '';
  public toggleVideoFlag: boolean = false;
  public pictureTaken: boolean = false;
  public result: BiometryValidationResponse = new BiometryValidationResponse();

  @Input() biometryCompleted = false;

  errorTextUser = "del jefe de tienda";

  branchesDisabledparam: string = "";
  biometryAuthParam: string = "no";
  constructor(
    private datePipe: DatePipe,
    private biometryService: BiometryService,
    private configService: ConfigurationService,
    private readonly authService: AuthService,
    private floatingService: PosFloatingActionButtonService,
    private readonly exceptionSolutionService: ExceptionSolutionService,
    private readonly router: Router,
    private readonly paramsService: ParamsService,
    private readonly observationService: PosOrderObservationsService
  ) {
    this.floatingService.removeItems();
  }
  async ngOnInit(): Promise<void> {
    this.branchesDisabledparam = (await this.paramsService.readParam("biometry-authorization-disabled-branches").toPromise()).response?.value ?? "";
    await this.loadAuthParam();
    if (this.isDisabledCreditAuth) {
      this.errorTextUser = "del jefe de tienda";
    }
    else {
      this.errorTextUser = "a créditos"
    }
  }

  private async loadAuthParam() {
    this.biometryAuthParam = (await this.paramsService.readParam("enable-biometry-authorization-credit").toPromise()).response?.value ?? "no";
  }

  async onFileChange(event: any) {
    let img = new Image();
    let ctx = this.uploadCanvas?.nativeElement.getContext('2d');
    ctx.clearRect(0, 0, 640, 480);
    img.onload = () => {
      var hRatio = 640 / img.width;
      var vRatio = 480 / img.height;
      var ratio = Math.min(hRatio, vRatio);
      ctx.drawImage(
        img,
        0,
        0,
        img.width,
        img.height,
        0,
        0,
        img.width * ratio,
        img.height * ratio
      );
      this.picture = this.uploadCanvas.nativeElement.toDataURL('image/jpeg');
    };
    img.src = await FileUtils.getBase64(event.target.files[0]);
    this.filename = event.target.files[0].name;
  }

  async handleSelectedCustomerChange(customerData: {
    customer: Customer;
    customerCreditConditions: CreditStatusFranchisedResponseModel;
  }): Promise<void> {
    this.customer = customerData.customer;
    this.deletePicture();
    this.clear();
  }

  clear() {
    this.result = new BiometryValidationResponse();
    this.biometryFingerPrintComponent.clean();
    this.cleanEmitter.emit();
  }

  toggleVideo(toggle: boolean, pictureTaken?: boolean) {
    let video = this.hardwareVideo.nativeElement;

    var n = navigator as any;

    n.getUserMedia =
      n.getUserMedia ||
      n.webkitGetUserMedia ||
      n.mozGetUserMedia ||
      n.msGetUserMedia;

    n.mediaDevices.getUserMedia({ video: true }).then(function (stream: any) {
      if (toggle) {
        video.srcObject = stream;
        video.play();
      } else {
        video.srcObject = null;
        video.stop();
      }
    });
    this.toggleVideoFlag = toggle;
    this.pictureTaken = pictureTaken == true;
    // NOTE: For Video + Audio
    // n.mediaDevices.getUserMedia({video: true, audio: true}).then(function(stream) {
    //     video.src = window.URL.createObjectURL(stream);
    //     video.play();
    // });
  }
  public capturePhoto() {
    if (!this.hardwareVideo || !this.toggleVideoFlag) {
      return;
    }
    var context = this.takenCanvas.nativeElement
      .getContext('2d')
      .drawImage(this.hardwareVideo.nativeElement, 0, 0, 640, 480);
    this.picture = this.takenCanvas.nativeElement.toDataURL('image/jpeg');
    this.filename = `${this.customer.code}_${this.datePipe.transform(
      new Date(),
      'YYYYMMDDHHmmSS'
    )}.jpg`;
    this.toggleVideo(false, true);
    this.pictureTakenEmitter.emit(this.picture);
  }

  public deletePicture() {
    this.picture = '';
    this.toggleVideo(false);
    this.clear();
  }

  public async validatePicture() {
    if (this.picture == ``) {
      this.exceptionSolutionService.showAlertWithSolution('Biometría', `Toma foto web antes de validar`);
      return;
    }

    try {
      this.result = new BiometryValidationResponse();
      this.result = (
        await this.biometryService
          .validateBiometry({
            branchCode:
              this.configService.readSelectedBranchAndSalesOrg().branch.code,
            customerCode: this.customer.code,
            imageFileName: this.filename,
            imageStringBase64: this.picture,
            type: BiometryType.PHOTO,
            user: (await this.authService.readProfile()).username,
            orderCode: this.orderCode,
            creditRequestNumber: this.creditRequestNumber,
            selectedUserBranchCode: this.selectedUserBranchCode,
            selectedUserSalesOrg: this.selectedUserSalesOrg,
            cashLoanReasonCode: this.cashLoanReasonCode,
            cashLoanReasonDescription: this.cashLoanReasonDescription,
          })
          .toPromise()
      ).response;

      this.biometryResultEmitter.emit(this.result);
    } catch (error) {
      this.biometryErrorEmitter.emit(error);

      throw error;
    }
  }

  getOrderCode() {
    if (this.isForCreditRequest) {
      return this.creditRequestNumber;
    }

    if (this.isForInvoice) {
      return this.orderCode;
    }

    return "";
  }

  goToAuthToken() {
    this.router.navigate(["biometry", "authTokenAuthorization"])
  }
  get isDisabledCreditAuth() {
    return this.branchesDisabledparam.includes(this.configService.readSelectedBranchAndSalesOrg().branch.code) || this.biometryAuthParam.toLowerCase() == "no" || this.isForCashLoan || this.isForCreditRequest;
  }

  async updateAuthCredit(active: boolean, observations: string) {
    const request = new BiometryAuthCreditRequest();

    request.authCredit = active;
    request.observations = observations;
    await this.biometryService.updateAuthorizationCredit(request, this.authService.currentSuperTokenValue).toPromise();
  }

  async deactivateAuthCredit() {
    const observations = await this.observationService.showUnlockOrderObservations("", false, "Desactivar la Autorización de Biometría con Créditos") ?? "";
    if (observations) {
      await this.updateAuthCredit(false, observations);
      await this.loadAuthParam();
      Swal.fire({
        title: 'Autorización de Biometría con Créditos',
        text: 'Se ha desactivado la Autorización de Biometría con Créditos',
        icon: 'warning',
        confirmButtonText: 'Aceptar',
      });
    }

  }

  async activateAuthCredit() {
    const observations = await this.observationService.showUnlockOrderObservations("", false, "Activar la Autorización de Biometría con Créditos") ?? "";
    if (observations) {
      await this.updateAuthCredit(true, observations);
      await this.loadAuthParam();
      Swal.fire({
        title: 'Autorización de Biometría con Créditos',
        text: 'Se ha activado la Autorización de Biometría con Créditos',
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
    }
  }

  get isAuthActive() {
    return this.biometryAuthParam.toUpperCase() == "SI";
  }
}
